















import Vue from 'vue';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { PageBanner } from '@/components/page-components';

export default Vue.extend({
  name: 'AccountSettings',
  beforeRouteEnter(to, from, next) {
    const requests = [
      store.dispatch('getAccounts'),
      store.dispatch('getPersonalInformation'),
      store.dispatch('getBankingInformation'),
      store.dispatch('getARIDesignees'),
      store.dispatch('getHealthPlanOptions'),
    ];
    LoadingService.watchPromises(requests)
      .then(() => {
        if (store.getters.hasActiveHSA || store.getters.hasActiveVEBA) {
          const promises = [];
          for (let i = 0; i < store.getters.activeHSAAccounts.length; i++) {
            const account = store.getters.activeHSAAccounts[i];
            promises.push(
              store.dispatch('getMemberPlanTypeOptions', account.accountId),
            );
            if (account.allowBeneficiaryChange) {
              promises.push(
                store.dispatch('getBeneficiaryInformation', account.accountId),
              );
            }
          }
          for (let i = 0; i < store.getters.activeVEBAAccounts.length; i++) {
            const account = store.getters.activeVEBAAccounts[i];
            promises.push(
              store.dispatch('getMemberPlanTypeOptions', account.accountId),
            );
            if (account.allowBeneficiaryChange) {
              promises.push(
                store.dispatch('getBeneficiaryInformation', account.accountId),
              );
            }
          }
          LoadingService.watchPromises(promises)
            .then(next)
            .catch(() => {
              EventBus.$emit('openModal', 'Error', {
                message: 'global_connection-error',
                action: {
                  label: 'global_try-again',
                  performAction() {
                    location.reload();
                  },
                },
                hideCancel: true,
              });
              EventBus.$emit('initialLoadDone');
            });
        } else {
          next();
        }
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  computed: {
    parentMeta(): any {
      if (
        this.$route.meta.title &&
        typeof this.$route.meta.subtitle !== 'undefined'
      ) {
        return this.$route.meta;
      }

      const matches = this.$route.matched.slice(0).reverse();
      for (let i = 0; i < matches.length; i++) {
        const route = matches[i],
          routeParent = route.parent,
          routeParentMeta = routeParent.meta;

        if (
          routeParentMeta.title &&
          typeof routeParentMeta.subtitle !== 'undefined'
        ) {
          return routeParentMeta;
        }
      }

      return {};
    },
  },
  components: {
    PageBanner,
  },
});
